// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopFilledSvg from "@fishx/icons-svg/es/asn/ShopFilled";
import FishxIcon from '../components/FishxIcon';

var ShopFilled = function ShopFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopFilledSvg
  }));
};

ShopFilled.displayName = 'ShopFilled';
export default React.forwardRef(ShopFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShopFilled.js
// module id = 4095
// module chunks = 0